import 'component/css/weekday-picker.css';
import React, { useState, useEffect } from 'react';

const ServiceWeekdayPicker = ({plan,d1,d2,d3,readonly,...props}) =>
{
  const initDict = (d1,d2,d3) => {
    let d = {
      1: false, 2: false, 3: false,
      4: false, 5: false, 6: false, 7: false
    };
    [d1,d2,d3].forEach(x => { if (x) d[x] = true });
    return d;
  }

  let [dict, setDict] = useState(initDict(d1,d2,d3));

  useEffect(() => {
    setDict(initDict(d1,d2,d3));
  }, [d1,d2,d3,plan]);

  const toggleDay = (e,d) =>
  {
    e.stopPropagation();
    e.preventDefault();

    let D = {...dict};
    D[d] = !D[d];
    let count = [1,2,3,4,5,6,7].reduce((r,i) => D[i]?++r:r, 0);
    let allow = {A:0,B:3,C:1,filter:7}[plan]||0;
    if (count <= allow) {
      setDict(D);
      let [d1,d2,d3] = [7,6,5,4,3,2,1].reduce((r,i) => {
        if (D[i]) r.unshift(i);
        return r;
      }, [0,0,0]);
      props.onChange(d1,d2,d3,D);
    }
  }

  const SWButton = ({text,i}) => {
    let b  = !!dict[i] || (plan == 'A' && i != 6);
    let cn = `d${i}` + (b?' selected':'');
    return <button type="button" className={cn}
                   onClick={readonly || (e=>toggleDay(e,i)) }>{text}</button>;

  }

  return (
    <div className="weekday-picker">
      <SWButton i={7} text={'日'} />
      <SWButton i={1} text={'一'} />
      <SWButton i={2} text={'二'} />
      <SWButton i={3} text={'三'} />
      <SWButton i={4} text={'四'} />
      <SWButton i={5} text={'五'} />
      <SWButton i={6} text={'六'} />
    </div>
  );

}

export default ServiceWeekdayPicker;